import React from 'react';
import T from 'prop-types';

import Button from '../../../../Buttons/Button';
import ThresholdBadge from '../../../../ThresholdBadge';
import InsightsCardBox from '../../../../../pages/app-insights/_shared/components/InsightsCardBox';

import links from '../../../configs/links';

const KpiForecastsQV = ({
  app,
  forecasts,
}) => (
  <InsightsCardBox
    bodyMinHeight={106}
    className="kpi-forecasts-qv card-box-sm"
    headerLeft={<h4 className="h4">KPI Forecasts</h4>}
    headerRight={(
      <Button variant="secondary" size="sm" href={links.overview(app.store, app.ref_no)}>
        View Forecast
      </Button>
    )}
  >
    <div className="kpi-forecasts-qv__trow">
      <div className="kpi-forecasts-qv__thcell">KPI</div>
      <div className="kpi-forecasts-qv__thcell text-right">vs. Consensus</div>
    </div>
    {forecasts.map(item => (
      <div key={item.kpi_id} className="kpi-forecasts-qv__trow">
        <div className="kpi-forecasts-qv__tdcell text-truncate">
          {item.kpi_name}
        </div>
        <div className="kpi-forecasts-qv__tdcell">
          <ThresholdBadge
            value={item.forecasts.delta ? parseFloat(item.forecasts.delta).toFixed(1) : null}
            threshold={[1, -1]}
            displayMode="label"
          />
        </div>
      </div>
    ))}
  </InsightsCardBox>
);

KpiForecastsQV.propTypes = {
  app: T.shape({
    store: T.string,
    ref_no: T.oneOfType([T.string, T.number]),
  }).isRequired,
  forecasts: T.array.isRequired,
};

export default KpiForecastsQV;
